import {ConfigEvr} from './config.evr';

export const configApp: ConfigEvr = initEnvirenement();


function initEnvirenement(): ConfigEvr {


	//- choisir l'envirement via URL
	let domaine = getAbsoluteDomainUrl();

	let http = domaine.indexOf('https://') == 0 ? 'https://' : 'http://';
	http = domaine.indexOf(http + 'www') == 0 ? http + 'www.' : http;


	let config: ConfigEvr = new ConfigEvr(http);

	domaine = domaine.indexOf('localhost') > 0 ? 'localhost' : domaine;

	switch (domaine) {

		// mode dévloppement
		case 'localhost':
		case 'http://www.teste.com':
			config.configApp_dev();
			break;

		// mode teste niveau alpha
		case 'https://alpha.utool.fr':
		case 'https://www.alpha.utool.fr':
		case 'http://alpha.utool.fr':
		case 'http://www.alpha.utool.fr':
			config.configApp_beta();
			break;

		// mode prod niveau beta
		case 'https://beta.utool.fr':
		case 'https://www.beta.utool.fr':
		case 'http://beta.utool.fr':
		case 'http://www.beta.utool.fr':
			config.configApp_beta();
			break;

		// mode prod niveau stable
		case 'https://app.utool.fr':
		case 'https://www.app.utool.fr':
		case 'http://app.utool.fr':
		case 'http://www.app.utool.fr':
			config.configApp_prod();
			break;

		// Autres APP
		// 1.utoolAdmin
		case 'https://admin.utool.fr':
		case 'https://www.admin.utool.fr':
		case 'http://admin.utool.fr':
		case 'http://www.admin.utool.fr':
			config.configApp_admin('prod');
			break;

		// 2.beintooDistributeur
		case 'https://distributeur.utool.fr':
		case 'https://www.distributeur.utool.fr':
		case 'http://distributeur.utool.fr':
		case 'http://www.distributeur.utool.fr':
			config.configApp_distributeur('beta');
			break;


    // 3. beintooSite
    case 'https://utool.fr':
    case 'https://www.utool.fr':
    case 'http://utool.fr':
    case 'http://www.utool.fr':
      config.configApp_site('beta');
      break;

	}


	return config;
}


function getAbsoluteDomainUrl(): string {
	if (window
		&& 'location' in window
		&& 'protocol' in window.location
		&& 'host' in window.location) {
		return window.location.protocol + '//' + window.location.host;
	}
	return null;
}

